
type Enums<T, Enum extends string> = T & { __enum: Enum };

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const makeEnumType = <const T extends Record<string, string>>(obj: T, key : string) => {
    return Object.fromEntries(
        Object.entries(obj).map(([k, v]) => [
            k,
            v as Enums<typeof v, typeof key>,
        ]),
    ) as {
        [K in keyof T]: Enums<T[K], typeof key>;
    };
};